import React from 'react';
const facts = [{
  value: '300',
  label: 'Ready-to-use pages across 6 volumes',
  tint: 'bg-teal-soft'
}, {
  value: '131',
  label: 'Ready-to-run Lesson Cards',
  tint: 'bg-peach-soft'
}, {
  value: '3',
  label: 'Wind versions in every lesson',
  tint: 'bg-sage-soft'
}, {
  value: '24',
  label: 'Printable worksheets (WS-01 to WS-24)',
  tint: 'bg-lav-soft'
}];
export function SocialProofBar() {
  return <section className="w-full bg-white" data-id="element-239" data-mp="32jczgneq3egh">
      <div className="mx-auto max-w-6xl px-5 pb-14 sm:pb-16" data-id="element-240" data-mp="32ibm2ca8ifvl">
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-241" data-mp="2xjrw80sisjxy">
          {facts.map(fact => <div key={fact.label} className={`rounded-2xl px-4 py-5 text-center ${fact.tint}`} data-id="element-242" data-mp="2thdgvqo282bf">
              <div className="font-display text-3xl leading-none text-navy sm:text-4xl" data-id="element-243" data-mp="2ok4zvtene4br">{fact.value}</div>
              <div className="mt-2 text-xs font-semibold text-navy-soft" data-id="element-244" data-mp="1i4aycq2eh2om">{fact.label}</div>
            </div>)}
        </div>
      </div>
    </section>;
}